import React from 'react'
import { Card } from '@etiquette-ui/misc';
import { useStaticQuery, graphql } from "gatsby";
import styled from 'styled-components';
import { device } from '../../../../Theme';
import Img from 'gatsby-image';
import { TEXT } from '@etiquette-ui/colors';

import useI18n from '../../../../i18n/useI18n';

const Column = styled.div`
    width: 90%;
    margin: 0 auto;

    margin-top: 100px;
    padding-bottom: 60px;
    display: grid;
    grid-gap: 10px;
    justify-items: center;
    align-items: center; 
    grid-template-columns: 100%;
    max-width: 730px;
`;
const Container = styled(Card)`
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-areas: 'icons texttool';
    height: 248px;
    align-items: center;

    @media ${device.mobileXL} { 
        width: 100%;
        height: 100%;
        grid-template-columns: 1fr;
        grid-template-areas: 'texttool'
                         'icons';
        
    }
    @media ${device.mobileL} { 
        padding: 40px 0px 60px 0px;
    }
    .texttool{
        grid-area: texttool;
        justify-self: center;
    }
    .icons{
        grid-area: icons;
        justify-self: center;
    }
`;
const Text = styled.div`
    color: ${TEXT};

    h3 {
        margin: 0;

        @media ${device.mobileXL} { 
            padding: 0;
            margin: 0;
            margin-top: -10px;
        }
    }
    p {
       
        @media ${device.mobileXL} { 
            margin-top: 5px;
        }
        @media ${device.mobileL} { 
            width: 250px;
        }
        @media ${device.mobileS} { 
            width: 180px;
        }
    }
`;
const Image = styled.div`
    width: 180px;
    height: 90px;
    margin-left: -80px;  

    @media ${device.tablet} { 
        width: 140px;
        margin-left: -70px; 
    }
    @media ${device.mobileL} { 
        width: 180px;
    }
`;
const ImgGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    align-items: center;
    margin-top: -60px;
    margin-left: 50px;

    @media ${device.tablet} { 
        margin-top: -30px;
    }
    @media ${device.mobileXL} { 
        margin-left: 70px;
    }
    @media ${device.mobileL} { 
        grid-template-columns: repeat(2, 1fr);
    }
    @media ${device.mobileS} { 
        margin-left: 50px;
    }
`;
const AllTools = () => {
    const { translateObject } = useI18n();
    const data = useStaticQuery(Apps);
    const dataimage = data.allFile.edges;
    const icons = [3, 5, 7, 1, 4, 2, 8, 6];

    return (
        <Column>
            <Container >
                <ImgGrid className='icons'>
                    {icons.map(item => <Image>
                        <Img
                            fluid={dataimage[item].node.childrenImageSharp[0].fluid}
                            alt={dataimage[item].node.base}
                        />
                    </Image>
                    )}
                </ImgGrid>

                <Text className='texttool'>
                    <h3>
                        {translateObject({
                            en: `All tools!`,
                            es: `¡Todas las herramientas!`
                        })}
                    </h3>
                    <p>
                        {translateObject({
                            en: `With Admin Site you control access to all tools.`,
                            es: `Con Admin Site tú tienes el acceso a todo.`
                        })}
                    </p>
                </Text>
            </Container>
        </Column>
    )
};
export default AllTools;

const Apps = graphql`
query alltools {
    allFile(
      filter: {
        extension: {regex: "/(png)/"}, 
        name: {in: [
            "digitalmenu-icon",
            "managersite-icon",
            "reservations-icon",
            "surveycreator-icon",
            "dotell-icon",
            "dashboard-icon",
            "taskme-icon",
            "adminsite-icon",
            "appsinti-icon",
        ]}}
    ) {
      edges {
        node {
          base
          childrenImageSharp {
            fluid(quality: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
  }
`;